import { render, staticRenderFns } from "./dorse.type.select.vue?vue&type=template&id=c6906c28"
import script from "./dorse.type.select.vue?vue&type=script&lang=js"
export * from "./dorse.type.select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports